/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { memo } from 'react';
import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        text: {
            textAlign: 'center',
            maxWidth: 350,
        },
        link: {
            margin: theme.spacing(0, 0.5, 0, 0.5),
        },
    }),
);

interface RecaptchaLinksProps {
    linkColor?: string;
}

const RecaptchaLinks = (props: RecaptchaLinksProps) => {
    const classes = useStyles();
    const { linkColor } = props;

    return (
        <Typography className={classes.text} variant={'body2'} color="secondary">
            This site is protected by reCAPTCHA and the Google
            <a
                className={classes.link}
                style={{ color: linkColor ? linkColor : null }}
                href="https://policies.google.com/privacy"
            >
                Privacy Policy
            </a>{' '}
            and
            <a
                className={classes.link}
                style={{ color: linkColor ? linkColor : null }}
                href="https://policies.google.com/terms"
            >
                Terms of Service
            </a>{' '}
            apply.
        </Typography>
    );
};

export default memo(RecaptchaLinks);
